import React from "react"
import PopoverMenu from "../../../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const";
import QuickSearch_Fields from "../../model/fields";
import FieldFormElementView from "../../../../../core/fields3/render/form-elemnent-view";

const debug = false
// const debug = "QuickSearch_SettingsPopover"

type Props = {
    onSettingsChanged  : callback
}

export default function QuickSearch_SettingsPopover(props:Props) {


    const fields = new QuickSearch_Fields()

    const update = (settingName:string, value:boolean) => {

        debug && console.log(debug, 'update value=', value, 'settingName=', settingName)

        // @ts-ignore
        gd.user.settings.quickSearch[settingName] = value
        gd.user.settings.save()

        props.onSettingsChanged?.()
        // forceUpdate()
    }

    const options : Options = []

    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : fields.tasksByTitle.label,
        component   : (
            <FieldFormElementView field={fields.tasksByTitle} model={gd.user.settings.quickSearch} onChange={(value)=>{update('tasksByTitle', value)}} />
        ),
    })

    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : fields.tasksByShortId.label,
        component   : (
            <FieldFormElementView field={fields.tasksByShortId} model={gd.user.settings.quickSearch} onChange={(value)=>{update('tasksByShortId', value)}} />
        ),
    })

    // show only if any of tasks selected
    if (fields.tasksByShortId || fields.tasksByTitle) {
        options.push({
            type        : PopoverMenuItemType.SETTING,
            label       : fields.tasksClosed.label,
            component   : (
                <FieldFormElementView field={fields.tasksClosed} model={gd.user.settings.quickSearch} onChange={(value)=>{update('tasksClosed', value)}} />
            ),
        })
    }

    options.push({
        type        : PopoverMenuItemType.SEPARATOR
    })


    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : 'Projects & Resources',
        component   : (
            <FieldFormElementView field={fields.projects} model={gd.user.settings.quickSearch} onChange={(value)=>{update('projects', value)}} />
        ),
    })

    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : 'Documents',
        component   : (
            <FieldFormElementView field={fields.documents} model={gd.user.settings.quickSearch} onChange={(value)=>{update('documents', value)}} />
        ),
    })

    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : fields.users.label,
        component   : (
            <FieldFormElementView field={fields.users} model={gd.user.settings.quickSearch} onChange={(value)=>{update('users', value)}} />
        ),
    })

    options.push({
        type        : PopoverMenuItemType.SETTING,
        label       : fields.modules.label,
        component   : (
            <FieldFormElementView field={fields.modules} model={gd.user.settings.quickSearch} onChange={(value)=>{update('modules', value)}} />
        ),
    })


    return (
        <PopoverMenu className      = "search-settings-popover w-250"
                     options        = {options}
                     hidePopover    = {gd.layout.popovers.closeAll} />
    )
}